<template>
  <div id="rate-breakdown-window">
    <section id="rate-breakdown-box" class="box-shadow col-xs-12 col-sm-10 col-lg-8 col-sm-offset-1 col-lg-offset-2">
      <header>
        <i class="ion ion-close-round sm" @click="close"></i>
        <blockquote>
          Accepted Route - Totals
        </blockquote>
      </header>
      <ul class="nav nav-pills nav-justified mai-nav-pills">
        <li @click="pill = 'overview'" :class="[ pill === 'overview' ? 'active' : '' ]"><a>Overview</a></li>
        <li v-if="accessorialsEnabled" @click="pill = 'accessorials'" :class="[ pill === 'accessorials' ? 'active' : '' ]"><a>Accessorials</a></li>
        <li @click="pill = 'costs'" :class="[ pill === 'costs' ? 'active' : '' ]"><a>Costs</a></li>
        <li @click="pill = 'charges'" :class="[ pill === 'charges' ? 'active' : '' ]"><a>Charges</a></li>
        <li @click="pill = 'compare'" :class="[ pill === 'compare' ? 'active' : '' ]"><a>Comparison</a></li>
      </ul>
      <main id="totals-table-container" class="clearfix box-shadow">
        <div v-show="pill === 'overview'">
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
              <tr>
                <th>Detail</th>
                <th>Input</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>First Name *</td>
                <td class="input-td">
                  <input class="is-input" v-model="firstName" @input="$emit('dataChange', {firstName})"/>
                </td>
              </tr>
              <tr>
                <td>Last Name *</td>
                <td class="input-td">
                  <input class="is-input" v-model="lastName" @input="$emit('dataChange', {lastName})"/>
                </td>
              </tr>
              <tr>
                <td>Pickup Date *</td>
                <td class="input-td">
                  <input type="date" class="is-input" v-model="pickUpDate" @input="validatePickUpDate"/>
                </td>
              </tr>
              <tr>
                <td>External Reference *</td>
                <td class="input-td">
                  <div v-show="invalidReferenceNumber" class="validation-error">Invalid Reference Number</div>
                  <div v-if="isCrownRefFormatEnabled" class="flex-container pull-right">
                    <input type="text" class="form-control" v-model="referenceNumber.text1" @blur="validateReferenceText1" style="width: 60px" />
                    <span class="input-group-addon" style="padding-right: 15px;">-</span>
                    <input type="text" class="form-control" v-model="referenceNumber.text2" @blur="validateReferenceText2" style="width: 80px" />
                    <span class="input-group-addon" style="padding-right: 15px;">-</span>
                    <input type="text" class="form-control" v-model="referenceNumber.text3" @blur="validateReferenceText3" style="width: 50px" />
                  </div>
                  <input v-else class="is-input" v-model="reference" @input="$emit('dataChange', {reference})"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
              <tr>
                <th>Service</th>
                <th>{{ response.responseCurrency }} Estimate</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="rate in rateServices">
                <td>{{ rate.serviceName }}</td>
                <td>{{ numberFormat(rate.cost) }}</td>
              </tr>
              <tr class="border-bottom-td border-top-td">
                <td></td>
                <td>{{ numberFormat(totalCost) }}</td>
              </tr>
              <tr v-for="f in copyOfFinanceItems">
                <td>{{ f.name }}</td>
                <td>{{ numberFormat(f.amount) }}</td>
              </tr>
              <tr style="background:#eee;">
                <td>Rate Adjustment</td>
                <td>{{ rateAdjustmentAmount !== 'N/A' ? numberFormat(rateAdjustmentAmount) : 'N/A' }}</td>
              </tr>
              <tr class="border-top-td">
                <td>Total Charge</td>
                <td class="input-td">
                  <input type="number" class="is-input" v-model="totalCharge" @input="updateChargesFromTotal"/>
                </td>
              </tr>
              <tr class="input-tr border-bottom-td">
                <td class="no-pad">
                  <select class="is-input" v-model="displayType">
                    <option value="lbs">Per 100 Lbs</option>
                    <option value="kg">Per Kg</option>
                    <option value="cuft">Per Cb.Ft</option>
                    <option value="cum">Per Cb.M</option>
                  </select>
                </td>
                <td class="input-td">
                  <input step="0.01" v-if="displayType === 'lbs'" type="number" class="is-input" v-model="lbs" @input="updateAfterLbsChange"/>
                  <input step="0.01" v-if="displayType === 'kg'" type="number" class="is-input" v-model="kg" @input="updateAfterKgChange"/>
                  <input step="0.01" v-if="displayType === 'cum'" type="number" class="is-input" v-model="cum" @input="updateAfterCumChange"/>
                  <input step="0.01" v-if="displayType === 'cuft'" type="number" class="is-input" v-model="cuft" @input="updateAfterCuftChange"/>
                </td>
              </tr>
              <tr v-if="accessorialsEnabled">
                <td class="sub-header"><b>Accessorials</b></td>
                <td class="sub-header"></td>
              </tr>
              <tr v-if="accessorialsEnabled">
                <td>Origin</td>
                <td>{{ numberFormat(originAccessorialsTotal) }}</td>
              </tr>
              <tr v-if="accessorialsEnabled" class="border-bottom-td">
                <td>Destination</td>
                <td>{{ numberFormat(destinationAccessorialsTotal) }}</td>
              </tr>
              <tr v-if="quoteTaxesEnabled">
                <td class="sub-header"><b>GST-VAT</b></td>
                <td class="sub-header"></td>
              </tr>
              <tr v-for="tax in taxes">
                <td>{{ tax.serviceName }} <span v-if="tax.note">({{ tax.note }})</span></td>
                <td>{{ numberFormat(tax.baseRate) }}%</td>
              </tr>
              <tr>
                <td colspan="2">&nbsp;</td>
              </tr>
              <tr class="border-top-td">
                <td>Profit</td>
                <td>{{ numberFormat(profit) }}</td>
              </tr>
              <tr>
                <td>Markup</td>
                <td>{{ markup }}%</td>
              </tr>
              <tr>
                <td>Gross Margin</td>
                <td>{{ grossMargin }}%</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="pill === 'accessorials'">
          <quote-accessorials
            :job="job && job.job"
            :reporting-currency="reportingCurrency"
            :rate="rate"
            :rate-request="request"
            :job-accessorials="jobAccessorials"
            @update-job-accessorials="updateJobAccessorials"
          />
        </div>
        <div v-if="pill === 'costs'">
          <div class="col-xs-12">
            <div class="clearfix">
              <div class="panel panel-default mai-panel">
                <div class="panel-heading"><i class="fa fa-bar-chart"></i> Costs by Service - Bar</small></div>
                <div class="panel-body clearfix" style="min-height: 380px;">
                  <simple-bar :chartData="costsBarData" valueField="Rate" categoryField="Service"></simple-bar>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="clearfix">
              <div class="panel panel-default mai-panel">
                <div class="panel-heading"><i class="fa fa-pie-chart"></i> Costs by Service - Pie</small></div>
                <div class="panel-body clearfix" style="min-height: 380px;">
                  <simple-pie :chartData="costsBarData" valueField="Rate" categoryField="Service"></simple-pie>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="pill === 'charges'">
          <div class="col-xs-12">
            <div class="clearfix">
              <div class="panel panel-default mai-panel">
                <div class="panel-heading"><i class="fa fa-bar-chart"></i> Charges by Service - Bar</small></div>
                <div class="panel-body clearfix" style="min-height: 380px;">
                  <simple-bar :chartData="chargesBarData" valueField="Amount" categoryField="Name"></simple-bar>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="clearfix">
              <div class="panel panel-default mai-panel">
                <div class="panel-heading"><i class="fa fa-pie-chart"></i> Charges by Service - Pie</small></div>
                <div class="panel-body clearfix" style="min-height: 380px;">
                  <simple-pie :chartData="chargesBarData" valueField="Amount" categoryField="Name"></simple-pie>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="pill === 'compare'">
          <div class="col-xs-12">
            <div class="clearfix">
              <div class="panel panel-default mai-panel">
                <div class="panel-heading"><i class="fa fa-bar-chart"></i> Costs by Service - Bar</small></div>
                <div class="panel-body clearfix" style="min-height: 380px;">
                  <simple-stacked-bar :chartData="stackedData" categoryField="Category"></simple-stacked-bar>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="clearfix">
              <div class="panel panel-default mai-panel">
                <div class="panel-heading"><i class="fa fa-pie-chart"></i> Costs by Service - Pie</small></div>
                <div class="panel-body clearfix" style="min-height: 380px;">
                  <simple-pie :chartData="costsCompare" valueField="Rate" categoryField="Service"></simple-pie>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer class="clearfix">
        <div class="pull-right full-w-sm">
          <div class="btn btn-success sq half-w-sm" @click="saveJob">
            Save <i class="fa fa-floppy-o"></i>
          </div>
          <div class="btn btn-primary sq half-w-sm"  @click="close">
            Back <i class="fa fa-backward"></i>
          </div>
        </div>
      </footer>
    </section>
  </div>
</template>
<script>
  import SimpleBar from '../../../components/charts/SimpleBar'
  import SimplePie from '../../../components/charts/SimplePie'
  import SimpleStackedBar from '../../../components/charts/SimpleStackedBar'
  import QuoteAccessorials from './QuoteAccessorials'
  import HelperMixin from '../../admin/mixins/Helpers'
  import API from '../../../api/endpoints'
  import event from '../../../event'
  import quotes from '../mixins/quotes'
  import { isPastDate } from '../../../util'
  export default {
    name: 'QuoteRateBreakDown',
    props: [ 'rate', 'reportingCurrency', 'fName', 'lName', 'request', 'response', 'puDate', 'job', 'brandGrp', 'prefWithNotes' ],
    mixins: [HelperMixin, quotes],
    data () {
      return {
        firstName: '',
        lastName: '',
        reference: '',
        pickUpDate: '',
        displayType: 'lbs',
        copyOfFinanceItems: [],
        jobAccessorials: [],
        totalCharge: 0,
        lbs: 0,
        kg: 0,
        cuft: 0,
        cum: 0,
        isInitialised: false,
        pill: 'overview',
        taxes: [],
        originAccessorialsTotal: 0,
        destinationAccessorialsTotal: 0,
        brandGroup: null
      }
    },
    components: {
      QuoteAccessorials,
      SimpleBar,
      SimpleStackedBar,
      SimplePie
    },
    watch: {
      jobAccessorials: {
        deep: true,
        handler: function (newVal) {
          this.originAccessorialsTotal = this.getAccessorialTotal(newVal, 'origin')
          this.destinationAccessorialsTotal = this.getAccessorialTotal(newVal, 'destination')
        }
      }
    },
    computed: {
      stackedData () {
        let costs = {
          Category: 'Costs'
        }
        this.rate.item.forEach(({ service, baseRate }) => {
          costs[service] = parseFloat(baseRate).toFixed(2)
        })
        let charges = {
          Category: 'Charges'
        }
        this.copyOfFinanceItems.forEach(({ name, amount }) => {
          charges[name] = parseFloat(amount).toFixed(2)
        })
        if (this.showAdditionCostItem) {
          charges['Rate Adjustment'] = parseFloat(this.rateAdjustmentAmount).toFixed(2)
        }
        return [ costs, charges ]
      },
      costsBarData () {
        return this.rate.item.map(({ service, baseRate }) => {
          return {
            Service: service,
            Rate: parseFloat(baseRate).toFixed(2)
          }
        })
      },
      chargesBarData () {
        let arr = this.copyOfFinanceItems.map(({ name, amount }) => {
          return {
            Name: name,
            Amount: parseFloat(amount).toFixed(2)
          }
        })
        if (this.showAdditionCostItem) {
          arr.push({
            Name: 'Rate Adjustment',
            Amount: parseFloat(this.rateAdjustmentAmount).toFixed(2)
          })
        }
        return arr
      },
      accessorialsEnabled () {
        return this.isSystemOptionParameterEnabled('ENABLE_ACCESSORIALS')
      },
      quoteTaxesEnabled () {
        return this.isSystemOptionParameterEnabled('ENABLE_QUOTE_TAXES')
      },
      costsCompare () {
        let costs = this.rate.item.map(({ service, baseRate }) => {
          return {
            Service: 'COST - ' + service,
            Rate: parseFloat(baseRate).toFixed(2)
          }
        })
        let charges = this.copyOfFinanceItems.map(({ name, amount }) => {
          return {
            Service: 'CHARGE - ' + name,
            Rate: parseFloat(amount).toFixed(2)
          }
        })
        if (this.showAdditionCostItem) {
          charges.push({
            Service: 'CHARGE - ' + 'Rate Adjustment',
            Rate: parseFloat(this.rateAdjustmentAmount).toFixed(2)
          })
        }
        return [ ...costs, ...charges ]
      },
      currencies () {
        return this.$store.getters['systemOption/currencies']
      },
      responseCurrency () {
        let cur = this.currencies.find(({code}) => code === this.response.responseCurrency)
        return cur ? cur.id : null
      },
      rateAdjustmentAmount () {
        return parseFloat(this.totalCharge - this.getTotalCharge).toFixed(2) === 0 ? 'N/A' : parseFloat(this.totalCharge - this.getTotalCharge).toFixed(2)
      },
      showAdditionCostItem () {
        return this.totalCharge !== this.getTotalCharge
      },
      financeItems () {
        return this.$store.getters['quote/financeItems']
      },
      displayVal () {
        switch (this.displayType) {
          case 'lbs':
            return (this.totalCharge / (this.request.WeightNetLbs / 100)).toFixed(2)
          case 'kg':
            return (this.totalCharge / this.request.WeightNetKgs).toFixed(2)
          case 'cuft':
            return (this.totalCharge / this.request.VolumeNetCuf).toFixed(2)
          case 'cum':
            return (this.totalCharge / this.request.VolumeNetCbm).toFixed(2)
        }
      },
      getTotal () {
        return this.rate.item.reduce((val, item) => {
          return val + parseFloat(item.baseRate)
        }, 0)
      },
      totalCost () {
        return parseFloat(this.getTotal.toFixed(2))
      },
      allServices () {
        return this.$store.getters['quote/allServices']
      },
      servicesCodeToName () {
        return this.allServices.reduce((val, {code, name}) => {
          val[code] = name
          return val
        }, {})
      },
      rateServices () {
        return this.rate.item.map(item => {
          return {
            serviceName: this.servicesCodeToName[item.service],
            cost: item.baseRate
          }
        })
      },
      taxRequests () {
        const baseReq = this.baseTaxRequest
        const taxRequests = this.rate.item.map(item => {
          const req = { ...baseReq }
          req.Service = item.service
          const isDestination = item.service === 'DA' || item.service === 'DZ'
          const details = item.details[0]
          req.Town = isDestination ? details.to : details.from
          req.State = isDestination ? details.toState : details.fromState
          req.Country = isDestination ? details.toCountry : details.fromCountry
          return req
        })
        const isDoorToStorage = this.request.JobType.includes('-D/S-')
        const isStorageToDoor = this.request.JobType.includes('-S/D-')
        if (isStorageToDoor) {
          taxRequests.push({
            ...baseReq,
            Service: 'ST',
            CallbackData: 'Destination',
            Town: this.request.DestinationTown,
            State: this.request.DestinationState,
            Country: this.request.DestinationCountry
          })
        } else {
          taxRequests.push({
            ...baseReq,
            Service: 'AC',
            CallbackData: 'Origin',
            Town: this.request.OriginTown,
            State: this.request.OriginState,
            Country: this.request.OriginCountry
          })
        }
        if (isDoorToStorage) {
          taxRequests.push({
            ...baseReq,
            Service: 'ST',
            CallbackData: 'Destination',
            Town: this.request.DestinationTown,
            State: this.request.DestinationState,
            Country: this.request.DestinationCountry
          })
        } else {
          taxRequests.push({
            ...baseReq,
            Service: 'AC',
            CallbackData: 'Destination',
            Town: this.request.DestinationTown,
            State: this.request.DestinationState,
            Country: this.request.DestinationCountry
          })
        }
        return taxRequests
      },
      baseTaxRequest () {
        const baseReq = { ...this.request }
        delete baseReq.OriginTown
        delete baseReq.OriginState
        delete baseReq.OriginCountry
        delete baseReq.DestinationTown
        delete baseReq.DestinationState
        delete baseReq.DestinationCountry
        return baseReq
      },
      profit () {
        return (this.totalCharge - this.totalCost).toFixed(2)
      },
      options () {
        return this.$store.getters['systemOption/options']
      },
      forwardingFee () {
        return this.options.find(({code}) => code === 'FORWARDING_FEE')
      },
      getTotalCharge () {
        let x = this.copyOfFinanceItems.reduce((val, { amount }) => {
          val += parseFloat(amount)
          return val
        }, 0)
        return x.toFixed(2)
      },
      markup () {
        return ((this.profit / this.totalCost) * 100).toFixed(2)
      },
      grossMargin () {
        return ((this.profit / this.totalCharge) * 100).toFixed(2)
      },
      saveRequestBody () {
        let req = {}
        req.rateRequest = {
          ...this.request,
          firstName: this.firstName,
          lastName: this.lastName,
          reference: this.reference,
          brandGroup: this.brandGroup
        }
        req.rateResponse = {
          ...this.response,
          selection: this.rate
        }
        let financeItems = [ ...this.copyOfFinanceItems ]
        if (this.showAdditionCostItem) {
          financeItems.push(this.additionChargeItem)
        }
        req.charges = financeItems.map(item => {
          delete item.name
          return item
        })
        if (this.getMasterJob) {
          req.masterJob = this.getMasterJob
        }
        req.accessorials = this.jobAccessorials
        req.taxes = this.taxes.map(item => {
          return { quoteTax: {...item}, serviceName: item.serviceName }
        })
        req.jobServiceNotes = this.prefWithNotes.map(item => {
          return { serviceCode: item.serviceCode, note: item.note }
        })
        return req
      },
      additionChargeItem () {
        return {
          name: 'Rate Adjustment',
          amount: this.rateAdjustmentAmount,
          currency: this.responseCurrency,
          category: 'CHARGE'
        }
      },
      getMasterJob () {
        return this.$route && this.$route.query && this.$route.query.masterJob
      },
      isPickUpDateValid () {
        return !this.pickUpDate || !isPastDate(this.pickUpDate)
      }
    },
    methods: {
      getAccessorialTotal (jobAccessorials, originOrDestination) {
        const c = originOrDestination === 'origin' ? 'O' : 'D'
        if (jobAccessorials && jobAccessorials.length) {
          const total = jobAccessorials
            .filter(item => (item.accessorial.service === `${c}A` || (item.accessorial.serviceClass && item.accessorial.serviceClass.code === `${c}A`)) ||
              (item.accessorial.service === `${c}Z` || (item.accessorial.serviceClass && item.accessorial.serviceClass.code === `${c}Z`)))
            .map(({baseSubtotal}) => baseSubtotal)
            .reduce((a, b) => a + b, 0)
          return total.toFixed(2)
        }
        return 0
      },
      initJobAccessorials () {
        this.jobAccessorials = []
        if (this.job && this.job.accessorials && this.job.accessorials.length) {
          this.jobAccessorials = this.job.accessorials
        }
      },
      saveJob () {
        if (this.isCrownRefFormatEnabled && !this.invalidReferenceNumber) {
          this.reference = this.crownReferenceNumber
        }
        if (this.firstName && this.lastName && this.pickUpDate && (!this.isCrownRefFormatEnabled || this.reference)) {
          this.$store.dispatch('quote/saveJob', this.saveRequestBody)
            .then(({data}) => {
              this.$emit('job-saved', data)
            }).catch(err => {
              this.$emit('job-save-error', err)
            })
        } else {
          event.$emit('toast', { type: 'warning', message: 'Please fill up required fields' })
        }
      },
      close () {
        this.$emit('close', {})
      },
      init () {
        let keysToRemoveFromFinanceItemToJobItem = [
          'calculation', 'financeProfile', 'specificToJobType', 'serviceType'
        ]
        this.copyOfFinanceItems = this.financeItems.map(o => {
          let obj = { ...o }
          obj.id = null
          obj.sourceAmount = Number(this.getSourceAmount(obj, obj.source))
          obj.markupAmount = Number(this.getMarkupAmount(obj, obj.markupType))
          obj.amount = this.getOverallAmount(obj, obj.totalType)
          obj.category = 'CHARGE'
          obj.financeProfileItem = o.id
          obj.currency = this.responseCurrency
          obj.financialCode = o.financialCode && o.financialCode.hasOwnProperty('id') ? o.financialCode.id : o.financialCode
          o.currency = this.responseCurrency
          keysToRemoveFromFinanceItemToJobItem.forEach(prop => {
            if (obj.hasOwnProperty(prop)) {
              delete obj[prop]
            }
          })
          return obj
        })
        this.initJobAccessorials()
        if (this.quoteTaxesEnabled) {
          this.initTaxes()
        }
        this.$nextTick(this.setTotals)
      },
      initTaxes () {
        const requests = this.taxRequests.map(req => {
          return this.$http.post(API.GET_TAXES, req)
        })
        Promise.all(requests).then(res => {
          const taxes = []
          res.forEach(response => {
            if (response.ok) {
              if (response.body.option && response.body.option.length > 0) {
                taxes.push(...response.body.option)
              }
            } else {
              console.log('Err', response)
            }
          })
          this.taxes = taxes.map(item => {
            return {
              serviceName: this.getServiceNameForTax(item),
              ...item
            }
          })
        })
      },
      getServiceNameForTax (item) {
        if (item.service === 'AC' && item.callbackData === 'Origin') {
          return 'Origin Accessorial'
        } else if (item.service === 'AC' && item.callbackData === 'Destination') {
          return 'Destination Accessorial'
        }
        return this.servicesCodeToName[item.service]
      },
      getOverallAmount (obj, type) {
        let val = 0
        switch (type) {
          case 'SOURCE':
            val = obj.sourceAmount || 0
            break
          case 'MARKUP':
            val = obj.markupAmount || 0
            break
          case 'SOURCE_AND_MARKUP':
            val = (obj.sourceAmount || 0) + (obj.markupAmount || 0)
            break
        }
        return val ? val.toFixed(2) : 0
      },
      getMarkupAmount (obj, type) {
        let val = 0
        if (type === 'LUMPSUM') {
          val = obj.baseAmount || obj.markupBy
        } else if (type === 'PERCENT') {
          val = (obj.sourceAmount * obj.markupBy) / 100
        }
        return val.toFixed(2)
      },
      getSourceAmount (obj, type) {
        let val = 0
        if (type === 'LUMPSUM') {
          val = obj.sourceAmount
        } else if (type === 'COST_SUBTOTAL' && obj.subtotal === 'ALL') {
          val = this.totalCost
        } else {
          val = this.rate.item.reduce((acc, {service, rate}) => {
            acc += service === obj.subtotal ? rate : 0
            return acc
          }, 0)
        }
        return val.toFixed(2)
      },
      setTotals () {
        this.totalCharge = this.getTotalCharge
        this.lbs = (this.totalCharge / (this.request.WeightNetLbs / 100)).toFixed(2)
        this.kg = (this.totalCharge / this.request.WeightNetKgs).toFixed(2)
        this.cuft = (this.totalCharge / this.request.VolumeNetCuf).toFixed(2)
        this.cum = (this.totalCharge / this.request.VolumeNetCbm).toFixed(2)
        this.isInitialised = true
      },
      updateJobAccessorials (accessorials) {
        this.jobAccessorials = accessorials.map(item => {
          return {
            accessorial: {
              id: item.accessorial.id,
              service: item.accessorial.service,
              description: item.description,
              rate: item.accessorial.rate,
              currency: item.accessorial.currency,
              baseRate: item.accessorial.baseRate,
              ratesPerName: item.accessorial.ratesPerName,
              minimumCost: item.accessorial.minimumCost
            },
            quantity: parseFloat(item.quantity),
            amount: item.rate,
            currency: { code: (item.accessorial.currency || item.currency.code) },
            baseAmount: parseFloat(item.baseRate),
            baseCurrency: { code: item.baseCurrency },
            exchangeRate: item.exchangeRate || item.accessorial.exchangeRate,
            subtotal: parseFloat(item.subtotal),
            baseSubtotal: parseFloat(item.baseSubtotal)
          }
        })
      },
      updateChargesFromTotal (e) {
        let newVal = parseFloat(e.target.value).toFixed(2)
        this.lbs = (newVal / (this.request.WeightNetLbs / 100)).toFixed(2)
        this.kg = (newVal / this.request.WeightNetKgs).toFixed(2)
        this.cuft = (newVal / this.request.VolumeNetCuf).toFixed(2)
        this.cum = (newVal / this.request.VolumeNetCbm).toFixed(2)
      },
      updateAfterLbsChange (e) {
        let newValLbs = parseFloat(e.target.value).toFixed(2)
        let newVal = (newValLbs * (this.request.WeightNetLbs / 100)).toFixed(2)
        this.totalCharge = newVal
        this.kg = (newVal / this.request.WeightNetKgs).toFixed(2)
        this.cuft = (newVal / this.request.VolumeNetCuf).toFixed(2)
        this.cum = (newVal / this.request.VolumeNetCbm).toFixed(2)
      },
      updateAfterKgChange (e) {
        let newValKg = parseFloat(e.target.value).toFixed(2)
        let newVal = (newValKg * this.request.WeightNetKgs).toFixed(2)
        this.totalCharge = newVal
        this.lbs = (newVal / (this.request.WeightNetLbs / 100)).toFixed(2)
        this.cuft = (newVal / this.request.VolumeNetCuf).toFixed(2)
        this.cum = (newVal / this.request.VolumeNetCbm).toFixed(2)
      },
      updateAfterCumChange (e) {
        let newValCum = parseFloat(e.target.value).toFixed(2)
        let newVal = (newValCum * this.request.VolumeNetCbm).toFixed(2)
        this.totalCharge = newVal
        this.lbs = (newVal / (this.request.WeightNetLbs / 100)).toFixed(2)
        this.cuft = (newVal / this.request.VolumeNetCuf).toFixed(2)
        this.kg = (newVal / this.request.WeightNetKgs).toFixed(2)
      },
      updateAfterCuftChange (e) {
        let newValCuft = parseFloat(e.target.value).toFixed(2)
        let newVal = (newValCuft * this.request.VolumeNetCuf).toFixed(2)
        this.totalCharge = newVal
        this.lbs = (newVal / (this.request.WeightNetLbs / 100)).toFixed(2)
        this.kg = (newVal / this.request.WeightNetKgs).toFixed(2)
        this.cum = (newVal / this.request.VolumeNetCbm).toFixed(2)
      },
      validatePickUpDate () {
        if (!this.isPickUpDateValid) {
          this.pickUpDate = null
          event.$emit('toast', { message: 'Please do not enter past date', type: 'warning' })
        }
        this.$emit('dataChange', {pickUpDate: this.pickUpDate})
      }
    },
    mounted () {
      this.firstName = this.fName
      this.lastName = this.lName
      this.pickUpDate = this.puDate
      this.brandGroup = this.brandGrp
      this.reference = this.request.Reference
      if (this.isCrownRefFormatEnabled && this.reference) {
        this.updateReferenceNumbers(this.reference)
      }
      this.init()
    }
  }
</script>
<style scoped>
  .box-shadow {
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: all 0.5s;
    padding: 10px;
    margin-bottom: 10px;
  }
  .box-shadow:hover {
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  input {
    text-align: right;
    padding-right: 1px;
  }
  .p9 {
    padding: 9px !important;
  }
  header {
    position: relative;
  }
  .ion-close-round {
    position: absolute;
    cursor: pointer;
  }
  .ion-close-round.sm {
    top: 0px;
    right: 0px;
  }
  .input-tr td.no-pad {
    padding: 0 !important;
    height: 37px;
  }
  .input-tr .is-input {
    height: 100%;
    width: 100%;
    border: none;
  }
  .input-td .is-input {
    height: 100%;
    width: 100%;
    border: none;
    padding-left: 9px;
  }
  .input-td {
    padding: 0 !important;
    height: 37px;
  }
  #rate-breakdown-window {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2222;
    background: rgba(51, 80, 86, 0.6);
  }
  #rate-breakdown-box {
    margin-top: 40px;
    background: #fff;
    padding:10px;
    max-height: 90%;
    overflow: auto;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.6;
    }
  }
  @keyframes fadeOut {
    from {
      opacity:0.6;
    }
    to {
      opacity: 0;
    }
  }
  thead {
    background-color: #428bca;
    color: #fff;
  }

  @media(max-width: 479px) {
    .full-w-sm {
      width: 100%;
    }
    .half-w-sm {
      width: 49%;
    }
  }
  tr td:nth-child(2) {
    text-align: left;
  }
  tbody tr td:nth-child(2) {
    text-align: right;
  }
  .border-bottom-td {
    border-bottom: 2px solid #000;
  }
  .border-top-td {
    border-top: 2px solid #000;
  }
  .mai-nav-pills {
    margin-bottom: 20px;
  }
  #totals-table-container {
    padding: 5px;
  }
  .sub-header {
    background-color: #428bca;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/QuoteRateBreakDown.vue